import { ArrowRight } from 'lucide-react'
import {
  Card,
  CardContent,
} from 'component_library/Lib_Design_System/base_components/ui/card'
import { Chip } from 'component_library/Lib_Design_System/block_components/selectors/Chip'
import { cn } from '@/lib/utils'
import { If } from '@/utility_components/ControlStatements'
import {
  FILTER_NUDGE_EYEBROW,
  FILTER_NUDGE_HEADING_ID,
  FILTER_NUDGE_HEADINGS,
  FILTER_NUDGE_SEE_ALL_LABEL,
  FILTER_NUDGE_SUBTEXTS,
  FilterNudgeQuestion,
} from './constants'
import { FilterNudgeChip } from './utils'

interface FilterNudgeCardProps {
  question: FilterNudgeQuestion
  chips: FilterNudgeChip[]
  onChipSelect: (chip: FilterNudgeChip) => void
  /** Shows the "See all" chip when provided. */
  onSeeAll?: () => void
  className?: string
}

const FilterNudgeCard: React.FC<FilterNudgeCardProps> = ({
  question,
  chips,
  onChipSelect,
  onSeeAll,
  className,
}) => {
  const headingId = FILTER_NUDGE_HEADING_ID
  const subtext = FILTER_NUDGE_SUBTEXTS[question]

  return (
    <Card
      className={cn(
        '~rounded ~border ~border-solid ~border-sunrise ~bg-white ~shadow-none',
        className
      )}
    >
      <CardContent className="~p-4">
        <section aria-labelledby={headingId}>
          <p className="~m-0 ~font-gibson ~text-2xs ~text-charcoal">
            {FILTER_NUDGE_EYEBROW}
          </p>
          <h3
            id={headingId}
            className="~m-0 ~mt-1 ~font-mrseavesxl ~text-xl ~font-bold ~text-black"
          >
            {FILTER_NUDGE_HEADINGS[question]}
          </h3>
          <If condition={!!subtext}>
            <p className="~m-0 ~mt-1 ~font-gibson ~text-2xs ~text-charcoal">
              {subtext}
            </p>
          </If>
          <div
            role="group"
            aria-labelledby={headingId}
            className="~mt-4 ~flex ~flex-wrap ~gap-3"
          >
            {chips.map((chip) => (
              <Chip
                key={chip.label}
                label={chip.label}
                icon={chip.icon}
                disabled={!chip.isAvailable}
                onClick={() => onChipSelect(chip)}
              />
            ))}
            <If condition={!!onSeeAll}>
              <Chip
                label={FILTER_NUDGE_SEE_ALL_LABEL}
                endIcon={<ArrowRight className="~h-4 ~w-4 ~text-navy" />}
                onClick={onSeeAll}
              />
            </If>
          </div>
        </section>
      </CardContent>
    </Card>
  )
}

export default FilterNudgeCard
